module.exports = __webpack_public_path__ + "img/img10.a761ee2c.png";